import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconPreviewStyle0 = cosmosIconCss;

const CosmosIconPreview$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPreview extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c25650687ae74136bbc101edf6c56e2a9722b8b9', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '5d6f571dd2cd365382a7db5d1e24354f9fb438d5', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a5d08c99ba007b3a169c0d57799797110c08af49', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.991 5c3.554 0 6.471 1.846 8.806 5.285a1.36 1.36 0 0 1 0 1.43l-.013.02C17.54 15.133 14.564 17 10.991 17c-3.57 0-6.523-1.861-8.775-5.27a1.342 1.342 0 0 1 .007-1.471C4.53 6.845 7.438 5 10.991 5Zm0 1.565c-2.943 0-5.37 1.514-7.383 4.436 1.965 2.91 4.426 4.434 7.383 4.434 2.962 0 5.442-1.53 7.403-4.433-2.028-2.925-4.462-4.437-7.403-4.437Zm0 1.565A2.866 2.866 0 0 1 13.854 11a2.866 2.866 0 0 1-2.863 2.87A2.866 2.866 0 0 1 8.128 11a2.866 2.866 0 0 1 2.863-2.87Zm0 1.566c-.719 0-1.301.584-1.301 1.304a1.302 1.302 0 1 0 2.603 0c0-.72-.583-1.304-1.302-1.304Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconPreviewStyle0; }
}, [1, "cosmos-icon-preview", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-preview"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-preview":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPreview$1);
            }
            break;
    } });
}

const CosmosIconPreview = CosmosIconPreview$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPreview, defineCustomElement };
